import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.3 0.5C1.301 0.5 0.5 1.301 0.5 2.3V11.3H2.3V2.3H11.3V0.5H2.3ZM5.9 4.1C4.901 4.1 4.1 4.901 4.1 5.9V14.9H5.9V5.9H14.9V4.1H5.9ZM9.5 7.7C8.501 7.7 7.7 8.501 7.7 9.5V16.7C7.7 17.699 8.501 18.5 9.5 18.5H16.7C17.699 18.5 18.5 17.699 18.5 16.7V9.5C18.5 8.501 17.699 7.7 16.7 7.7H9.5Z"
      fill="#222A5C"
    />
  </svg>,
  "PersonalizedGifsFilled"
);
